export default __webpack_public_path__ + "static/media/1.adf32a78.png";